export default __webpack_public_path__ + "static/media/loupe.fe50be4c.svg";